export default class FileHandler {
  constructor(filesPicker, fileContainer) {
    this.filesPicker = filesPicker;
    this.fileContainer = fileContainer;
    this.selectedFiles = [];
  }

  handleFileSelect() {
    const files = this.filesPicker.files;
    for (let i = 0; i < files.length; i++) {
      this.selectedFiles.push(files[i]);
    }

    this.updateFileDisplay();
    this.setFilePickerValue();
  }

  // SET THE FILESPICKER VALUE TO BE SELECTED FILES
  setFilePickerValue() {
    const dataTransfer = new DataTransfer();
    for (const file of this.selectedFiles) {
      dataTransfer.items.add(file);
    }
    this.filesPicker.files = dataTransfer.files;
  }

  updateFileDisplay() {
    this.fileContainer.innerHTML = "";
    this.selectedFiles.forEach((file) => {
      const fileItem = document.createElement("div");
      fileItem.innerHTML = `
            <div class="inline-flex items-center justify-between gap-1 text-sm px-3 py-1 border border-primary rounded text-primary">
              ${file.name}
              <i class="fa fa-times text-red-600 inline-block ml-1.5" aria-hidden="true"></i>
            </div>
          `;

      // Attach click event using addEventListener
      const removeIcon = fileItem.querySelector("i");
      removeIcon.addEventListener("click", () => this.removeFile(file.name));

      this.fileContainer.appendChild(fileItem);
    });
  }

  // DELETE SINGLE FILE
  removeFile(fileName) {
    this.selectedFiles = this.selectedFiles.filter(
      (file) => file.name !== fileName
    );
    this.setFilePickerValue();
    this.updateFileDisplay();
  }

  clearFiles() {
    this.selectedFiles = [];
    this.setFilePickerValue();
    this.updateFileDisplay();
  }
}
